<div class="label">
  <div class="w-full">
    {{ value }}
  </div>
  <ng-content></ng-content>
</div>
